import { UploadFile } from '@components/UI/media/uploadFile/UploadFile';

export class UploadCertificateFile extends UploadFile {
    static init($wrap, options) {
        super.init($wrap, options);
    }
}
